export const COMPONENT_NAME = "shared-estimate";
